import { openMeldRequestContextSchema } from "../daemon/profile-identity.js";
import * as z$1 from "zod/v4";
//#region src/schemas/http/local-agent-reasoning.ts
const OPENMELD_REASONING_STREAM_HEADER = "x-openmeld-reasoning-stream";
const LOCAL_AGENT_REASONING_MAX_CHARS = 8192;
const localAgentReasoningStateSchema = z$1.strictObject({
	status: z$1.enum([
		"waiting",
		"streaming",
		"disabled",
		"unavailable"
	]),
	firstOutputMs: z$1.number().int().nonnegative().optional()
});
const localAgentReasoningPreferencesSchema = z$1.strictObject({ enabled: z$1.boolean() });
const localAgentReasoningPreferencesRpcSchema = z$1.strictObject({
	context: openMeldRequestContextSchema,
	enabled: z$1.boolean().optional()
});
//#endregion
export { LOCAL_AGENT_REASONING_MAX_CHARS, OPENMELD_REASONING_STREAM_HEADER, localAgentReasoningPreferencesRpcSchema, localAgentReasoningPreferencesSchema, localAgentReasoningStateSchema };

//# sourceMappingURL=local-agent-reasoning.js.map